import { FileInput } from './FileInput'
import translate from '@/i18n/translate'

export class ImageInput extends FileInput {
  static defaultProps = {
    ...FileInput.defaultProps,
    labelMultiple: 'i18n.input.image.upload_several',
    labelSingle: 'i18n.input.image.upload_single',
  }
}

export default translate(ImageInput)



// WEBPACK FOOTER //
// ./ui/Input/ImageInput.js